enum ToastType {
    Info = 1,
    Success = 2,
    Error = 3,
    Warning = 4  
}
export {ToastType}
